import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BreadCumb, DataTables, NavBar, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import moment from "moment";

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Serie", value: true },//0
    { title: "Estatus", value: true },//1
    { title: "Num.Doc", value: true },//2
    { title: "Cliente", value: true },//3
    { title: "Nombre", value: true },//4
    { title: "Fecha Cont.", value: true },//5
    { title: "Comentarios", value: true },//6
    { title: "Empl. Ventas", value: true },//7
    { title: "Titular Doc.", value: true },//8
    { title: "Total", value: true },//9
    { title: "Fecha Entrega/ Vencimiento", value: true },//10
    { title: "Referencia", value: true },//11
    { title: "Docs Vencidos", value: true },//12
    { title: "Facturado", value: true },//13
    { title: "Pagado", value: true },//14
    { title: "Vencido", value: true }];//15

class DeliveriesView extends Component {

    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liEntre");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }

        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {
        
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || '---',
            groupCodeValue: newDate.groupCodeValue || '---',
            table: "ODLN",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--',
            searchSerieName: newDate.searchSerieName ? newDate.searchSerieName === '' ? '--' : newDate.searchSerieName : '--'
        };

        enableSpinner(true);
        let deliveriesListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (deliveriesListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            let dataSerie = {
                docType: "15",
                docSubType: "--"
            };

            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = user.U_FMB_ValidateSeriesODLN ? user.U_FMB_ValidateSeriesODLN : "";

            if (!user || ValidateSeries === "") {
                showAlert({ type: 'warning', timeOut: 5000, message: "Ocurrió un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador" });

                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.split("|");


            let newArraySeries = [];

            seriesUsers.map(serieUser => {
                seriesResponse.data.map(serieResponse => {
                    if (Number(serieResponse.Series) === Number(serieUser)) {
                        newArraySeries.push(serieResponse);
                    }
                    return null
                })
                return null
            })

            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }



            let newDocumentsfilterSeries = [];

            deliveriesListResponse.data.map(document => {
                newArraySeries.map(serie => {
                    if (Number(document.SeriesCode) === Number(serie.Series)) {
                        newDocumentsfilterSeries.push(document);
                    }
                    return null
                })
                return null
            });

            
            if(( newDate.docNumSearch && newDate.docNumSearch !== '--' ) || ( newDate.searchSerieName !== '--' && newDate.searchSerieName )){
                newDocumentsfilterSeries = deliveriesListResponse.data;
            }
            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        } else {
            showAlert({
                type: 'info',
                timeOut: 5000,
                message: "No se encontraron resultados correspondientes a la búsqueda."
            });

            this.setState({
                data: [],
            });
            return;
        }

        // showAlert({type: 'error', message: deliveriesListResponse.message});

    }


    searchDocuments = async date => {
        //console.log(date);
        await this.callDocumentsListService(date);
    };

    searchDocuments = async date => {
        //console.log(date);
        await this.callDocumentsListService(date);
    };

    render() {
        const { headers, data ,_user} = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <TimeOut />
                <BreadCumb subitem1={'ENTREGA'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <span href="#" id="linkOrdProv" className="text-muted">
                            &nbsp;ENTREGA
                        </span>
                    </h2>
                    <DataTables headers={headers} view={"deliveries"} data={data} search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeliveriesView);

